import Basic from '@/layouts/Basic';

const ResetPassword = () => import('@/views/resetPassword');

const router = [
    {
        path: '/reset-password',
        component: Basic,
        children: [
            {
                path: '',
                name: 'resetPassword',
                component: ResetPassword,
                meta: { title: 'Recuperar senha' },
            },
        ],
    },
];

export default router;
